export default {
    selectInviteList: "/gateway/huilianOperation/invitecs/selectInviteList", //拉新列表查询
    selectInvite: "/gateway/huilianOperation/invitecs/selectInvite", //我的邀请人
    determineInvite: "/gateway/huilianOperation/invitecs/determineInvite", //确定我的邀请人
};



// WEBPACK FOOTER //
// ./src/invitation/index/api.js